import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultWMS1030_R01Filter, WMS1030_R01Filter, useWMS1030_R01Store } from 'src/containers/mes/WMS/WMS1030_R01/Store_WMS1030_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteWMS1030_R01, downloadExcel_WMS1030_R01, getWMS1030_R01AllCount, getWMS1030_R01DetailList, getWMS1030_R01List, getWMS1030_R01LotList, getWMS1030_R01One, getWMS1030_R01TransportHeader, patchWMS1030_R01, postWMS1030_R01 } from "./Api_WMS1030_R01";
import { defaultWMS1030_R01DetailDto, defaultWMS1030_R01HeaderDto, defaultWMS1030_R01LotDto, WMS1030_R01DetailDto, WMS1030_R01Dto, WMS1030_R01HeaderDto, WMS1030_R01LotDto } from './Dto_WMS1030_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	WMS1030_R01_DETAIL_ROW_VALIDATE,
	WMS1030_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useWarehouseValidate } from 'src/utils/warehouse/WarehouseValidateContext';


interface Props {
	gridRef: React.RefObject<AgGridReact<WMS1030_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<WMS1030_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_WMS1030_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	
	const {
		WMS1030_R01Filter, setWMS1030_R01Filter,
		WMS1030_R01PastFilter, setWMS1030_R01PastFilter,
		WMS1030_R01List, setWMS1030_R01List,
		editWMS1030_R01, setEditWMS1030_R01,
		selectedWMS1030_R01, setSelectedWMS1030_R01, 
		deletedWMS1030_R01DetailList, setDeletedWMS1030_R01DetailList, addDeletedWMS1030_R01DetailList, removeDeletedWMS1030_R01DetailList, 
		selectedWMS1030_R01DetailList, setSelectedWMS1030_R01DetailList, addSelectedWMS1030_R01DetailList, removeSelectedWMS1030_R01DetailList,
		WMS1030_R01DetailList, setWMS1030_R01DetailList, insertWMS1030_R01DetailList,
		originalWMS1030_R01DetailList, setOriginalWMS1030_R01DetailList,
		deletedWMS1030_R01LotList, setDeletedWMS1030_R01LotList, addDeletedWMS1030_R01LotList, removeDeletedWMS1030_R01LotList, 
		selectedWMS1030_R01LotList, setSelectedWMS1030_R01LotList, addSelectedWMS1030_R01LotList, removeSelectedWMS1030_R01LotList,
		WMS1030_R01LotMap, setWMS1030_R01LotMap,
		setSelectedItemCdForLot,
		setWMS1030_R01LotList, insertWMS1030_R01LotList,
		originalWMS1030_R01LotList, setOriginalWMS1030_R01LotList,
		allCount, setAllCount,
		transportComplete, setTransportComplete,
		detailFetchTrigger, setDetailFetchTrigger,
		lotFetchTrigger, setLotFetchTrigger,
		initData,
		setScrollTop, setDetailScrollTop, setLotScrollTop,
	} = useWMS1030_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { inoutClassList, inoutTypeList, warehouseCdList, inoutMethodList, wmsCdList, compCdList, customCdList, employeeCdList, wmsOutTypeCdList, itemStatusList } = useCommonCodeStore();
	useFetchActionbarAuth("WMS1030_R01");

	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);
	const currentDetailListRef = useRef<WMS1030_R01DetailDto[]>([]);

	const { validateWorkplaceWarehouse } = useWarehouseValidate();

	const handleExcelClick = useCallback(async () => {
		if (!selectedWMS1030_R01) {
			showWarning("선택된 출고정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_WMS1030_R01('', selectedWMS1030_R01.wmsOrderNo, selectedWMS1030_R01!.warehouseCd!, WMS1030_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '출고정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedWMS1030_R01])

	const getParams = (filter: WMS1030_R01Filter) => {
		const params: Partial<WMS1030_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			wmsOrderNo: filter.wmsOrderNo || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getWMS1030_R01AllCount(getParams(WMS1030_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [WMS1030_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
		setLotScrollTop(null);
	
		const responseData = (await getWMS1030_R01List(
			'',
			getParams(WMS1030_R01Filter),
			WMS1030_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as WMS1030_R01HeaderDto[];
		setWMS1030_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedWMS1030_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedWMS1030_R01?.salBillNo)
			);
			setWMS1030_R01PastFilter(WMS1030_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedWMS1030_R01(defaultWMS1030_R01HeaderRow());
			setWMS1030_R01List([]);
			setWMS1030_R01DetailList([]); 
			setDeletedWMS1030_R01DetailList([]);
			setSelectedWMS1030_R01DetailList([]);
			setOriginalWMS1030_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [WMS1030_R01Filter, WMS1030_R01List, setWMS1030_R01List, setWMS1030_R01PastFilter, setSelectedWMS1030_R01, selectedWMS1030_R01, setScrollTop, setDetailScrollTop, setLotScrollTop])

	const fetchOne = useCallback(async () => {
		if (!selectedWMS1030_R01) return;
		
		const response = await getWMS1030_R01One(selectedWMS1030_R01.wmsOrderNo);

		return response.data.data;
	}, [selectedWMS1030_R01]);

	const fetchTransportHeader = useCallback(async () => {
		if (!selectedWMS1030_R01) return;

		const response = await getWMS1030_R01TransportHeader(selectedWMS1030_R01.wmsOrderNo);

		return response.data.data;
	}, [selectedWMS1030_R01]);

	const defaultWMS1030_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && (value.goodsYn === 'Y' || value.productYn === 'Y')
		);
		const inoutClassListToUse = inoutClassList.filter(item => item.minorCd === '230');

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(WMS1030_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				inoutClassList: inoutClassListToUse,
				inoutTypeList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultWMS1030_R01HeaderDto };
		}

		return {
			...defaultWMS1030_R01HeaderDto,
			inoutClass: inoutClassListToUse.find(value => value.minorCd === '230')?.minorCd || '',
			inoutType: inoutTypeList.find(value => value.minorCd === 'OUT')?.minorCd || '',
			compCd: compCdList[0].compCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			inserted: true,
		};
	}, [
		defaultWMS1030_R01HeaderDto, wmsCdList, warehouseCdList, compCdList, inoutClassList,
		validateCommonCodeLists,
	]);

	const defaultWMS1030_R01LotRow = useCallback(() => {
		return {
			...defaultWMS1030_R01LotDto,
			inserted: true,
		}
	}, [defaultWMS1030_R01LotDto]);

	const defaultWMS1030_R01DetailRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(WMS1030_R01_DETAIL_ROW_VALIDATE, {
				itemStatusList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultWMS1030_R01DetailDto };
		}

		return {
			...defaultWMS1030_R01DetailDto,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [defaultWMS1030_R01DetailDto, itemStatusList, validateCommonCodeLists]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedWMS1030_R01DetailList();
		removeSelectedWMS1030_R01DetailList();
		setEditWMS1030_R01({ ...defaultWMS1030_R01HeaderRow(), })
	}, [selectedWMS1030_R01])

	const handleDeleteClick = useCallback(() => {

		if (deletedWMS1030_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedWMS1030_R01DetailList(deletedWMS1030_R01DetailList);
			removeSelectedWMS1030_R01DetailList();
			setWMS1030_R01DetailList([...WMS1030_R01DetailList]);
		} else if (selectedWMS1030_R01DetailList.length > 0) {
			addDeletedWMS1030_R01DetailList(selectedWMS1030_R01DetailList);
			removeSelectedWMS1030_R01DetailList(selectedWMS1030_R01DetailList);
		}
	}, [selectedWMS1030_R01DetailList, 
		deletedWMS1030_R01DetailList,
		addDeletedWMS1030_R01DetailList,
		removeDeletedWMS1030_R01DetailList,
		removeSelectedWMS1030_R01DetailList,
		setWMS1030_R01DetailList,
		WMS1030_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedWMS1030_R01(undefined);
		setEditWMS1030_R01({ ...defaultWMS1030_R01HeaderRow(), })
		setWMS1030_R01DetailList([{ ...defaultWMS1030_R01DetailRow(), }]);
		setDeletedWMS1030_R01DetailList([]);
		setSelectedWMS1030_R01DetailList([]);
		setOriginalWMS1030_R01DetailList([]);
	}

	const validateInsertData = (header: WMS1030_R01HeaderDto, detailList: WMS1030_R01DetailDto[]) => {
		
		// if(!validateString(header.wmsOrderNo)) {
		// 	showWarning('출고지시번호를 입력해주세요.'); return false;
		// }
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (!validateWorkplaceWarehouse({
			mode: 'WMS1030_R01',
			warehouseCdList,
			wmsCdList,
			logicCenter: header.logicCenter,
		}).valid) {
			return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('창고번호를 선택해주세요.'); return false;
		}
		// if (!validateString(header.empNo)) {
		// 	showWarning('출고담당자를 선택해주세요.'); return false;
		// }
		// if (!validateEmployeeCd(header.empNo, employeeCdList)) {
		// 	showWarning('출고담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		// }
		if(!validateString(header.inoutMethod)) {
			showWarning('출고구분을 선택해주세요.'); return false;
		}

		if(detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}

		// 품목코드와 품목상태의 조합이 중복되는지 체크
		const itemStatusPairs = new Set<string>();
		for(const item of detailList) {
			if(!validateString(item.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if(!validateString(item.itemStatus)) {
				showWarning('품목의 상태를 선택해주세요.'); return false;
			}
			if(item.orderQty <= 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}

			const pair = `${item.itemCd}-${item.itemStatus}`;
			if (itemStatusPairs.has(pair)) {
				showWarning(`품목코드 '${item.itemCd}'와(과) 품목상태 '${item.itemStatus}'의 조합이 중복되었습니다.`);
				return false;
			}
			//중복되지 않으면 검증용 set에 추가
			itemStatusPairs.add(pair);

			if(item.stockQty < item.updateTransportQty) {
				showWarning(`출고량이 재고량보다 클 수 없습니다. - 품목코드: ${item.itemCd}`); return false;
			}

			if(item.orderQty < item.transportQty + item.updateTransportQty) {
				showWarning(`출고량이 주문출고량보다 클 수 없습니다. - 품목코드: ${item.itemCd}`); return false;
			}
		}
		

		return true;
	}

	const setInfoDetailList = useCallback((header: WMS1030_R01HeaderDto, detailList: WMS1030_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setWMS1030_R01DetailList])
	
	const setInfoLotList = useCallback((lotMap: Map<string, WMS1030_R01LotDto[]>): Record<string, WMS1030_R01LotDto[]> => {
		const filteredLotMap: Record<string, WMS1030_R01LotDto[]> = {};

		lotMap.forEach((lots, itemCd) => {
			const filteredLots = lots.filter(lot => lot.inputOutQty && lot.inputOutQty > 0 && lot.isModified === true);
			if (filteredLots.length > 0) {
				filteredLotMap[itemCd] = filteredLots;
			}
		});

		return filteredLotMap;
	}, [WMS1030_R01LotMap]);

	const refetchResponseDetailList = useCallback((responseData: WMS1030_R01Dto) => {
		const defaultItemStatus = defaultWMS1030_R01DetailRow().itemStatus;

		let detailDtoList = responseData.wmsOrderDetailDtoList;

		detailDtoList = detailDtoList.map(value => ({
			...value,
			itemStatus: validateString(value.itemStatus) ? value.itemStatus : defaultItemStatus,
			//주문잔량 다시 계산
			orderQtyView: value.orderQty - value.transportQty - value.updateTransportQty - value.cancelQty,
		}));

		//orderQtyView가 0이면 행을 삭제
		detailDtoList = detailDtoList.filter(value => value.orderQtyView > 0);
		responseData.wmsOrderDetailDtoList = detailDtoList;

		return responseData;
	}, [defaultWMS1030_R01DetailRow]);
	
	const handleSaveClick = useCallback(async () => {
		setLoadingSpinner(true);

		let valid = true;
		if(!validateInsertData(editWMS1030_R01!, WMS1030_R01DetailList)) valid = false;
		if(!valid) { setLoadingSpinner(false); return; }
		
		const lotMapObject = setInfoLotList(WMS1030_R01LotMap);
		const deletedWMS1030_R01DetailList_Number = deletedWMS1030_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: WMS1030_R01DetailDto[] = [];
		let newHeaderList: WMS1030_R01HeaderDto[] = [];		
		let responseData: WMS1030_R01Dto = {
			wmsOrderHeaderDto: editWMS1030_R01!,
			wmsOrderDetailDtoList: WMS1030_R01DetailList,
			wmsStockLotDtoList: lotMapObject
		};

		if (selectedWMS1030_R01 && selectedWMS1030_R01.wmsOrderNo !== '') {

			newDetailList = WMS1030_R01DetailList
			.map(value => ({
				...value,
				transportQty: value.transportQty + value.updateTransportQty,
			}))
			.filter(value => 
				!deletedWMS1030_R01DetailList_Number.includes(value.valueIndex)
			);

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deleteWMS1030_R01(selectedWMS1030_R01.wmsOrderNo);

				newHeaderList = WMS1030_R01List.filter(value => value.wmsOrderNo !== selectedWMS1030_R01.wmsOrderNo);

				if (deleteResponse && deleteResponse.data) {
					if (deleteResponse.data.successFlag) {
						showSuccess('출고내역이 삭제 되었습니다.');
						setMessage('출고내역이 삭제 되었습니다.');
					}else return;
				}
			} else {
				processName = 'patch';
				const patchResponse = await patchWMS1030_R01({
					wmsOrderHeaderDto: editWMS1030_R01!,
					wmsOrderDetailDtoList: setInfoDetailList(editWMS1030_R01!, newDetailList),
					wmsStockLotDtoList: lotMapObject
				});

				responseData = patchResponse.data.data[0];
				responseData = refetchResponseDetailList(responseData);
				newHeaderList = WMS1030_R01List.map(value => {
					if (value.wmsOrderNo === responseData.wmsOrderHeaderDto.wmsOrderNo) {
						return responseData.wmsOrderHeaderDto;
					}
					return value;
				});
				
				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

					showSuccess('출고내역이 등록 되었습니다.');
					setMessage('출고내역이 등록 되었습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('출고정보 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					return;
				}
			}
		} else {
			//예외출고 과정은 나중에 듣기 < 예외출고 없는거같음
			processName = 'post';
			const postResponse = await postWMS1030_R01({
				wmsOrderHeaderDto: editWMS1030_R01!,
				wmsOrderDetailDtoList: setInfoDetailList(editWMS1030_R01!, WMS1030_R01DetailList),
				wmsStockLotDtoList: lotMapObject
			});
			responseData = postResponse.data.data[0];
			responseData = refetchResponseDetailList(responseData);
			newHeaderList = [
				...WMS1030_R01List,
				responseData.wmsOrderHeaderDto, // responseData에서 헤더를 가져옵니다.
			] as WMS1030_R01HeaderDto[];
			
			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('출고내역이 등록 되었습니다.');
				setMessage('출고내역이 등록 되었습니다.');
			}else {
				showWarning('출고정보 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		}


		if (processName === 'delete') {
			setWMS1030_R01List(newHeaderList);
			setSelectedWMS1030_R01(undefined);
			setWMS1030_R01DetailList([]);
			// handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			
			if (responseData.wmsOrderHeaderDto!.closeTag === 'Y') {
				setWMS1030_R01List(newHeaderList.filter(value => value.wmsOrderNo !== editWMS1030_R01!.wmsOrderNo));
				setSelectedWMS1030_R01(undefined);
				setEditWMS1030_R01({ ...defaultWMS1030_R01HeaderRow(), })

				setWMS1030_R01DetailList([]);
				setOriginalWMS1030_R01DetailList([]);
				setWMS1030_R01LotList([]);
				setWMS1030_R01LotMap(new Map<string, WMS1030_R01LotDto[]>());
			}else{
				setWMS1030_R01List(newHeaderList);
				setWMS1030_R01DetailList(responseData.wmsOrderDetailDtoList.map(value => ({
					...value,
					updateTransportQty: 0
				})));

				setSelectedWMS1030_R01(responseData.wmsOrderHeaderDto);
				setOriginalWMS1030_R01DetailList(responseData.wmsOrderDetailDtoList);
				
				//wmsStockLotDtoList 맵 구성
				if (responseData.wmsStockLotDtoList) {
					const lotMapFromServer = responseData.wmsStockLotDtoList;
					const newLotMap = new Map<string, WMS1030_R01LotDto[]>();
	
					Object.values(lotMapFromServer).forEach((lotsFromServer) => {
						if(!lotsFromServer) return;

						// itemStatus별로 그룹핑
						const groupedByStatus = new Map<string, typeof lotsFromServer>();
						lotsFromServer.forEach(lot => {
							const key = `${lot.itemCd}-${lot.itemStatus}`;
							if(!groupedByStatus.has(key)) {
								groupedByStatus.set(key, []);
							}
							groupedByStatus.get(key)!.push(lot);
						});

						groupedByStatus.forEach((lots, key) => {
							let valueIndex = 1;
							const processedLots = lots.map(lot => ({
								...defaultWMS1030_R01LotDto,
								...lot,
								valueIndex: valueIndex++,
								isModified: false,
								inputOutQty: 0,
							}));
							newLotMap.set(key, processedLots);
						});
					});
					setWMS1030_R01LotMap(newLotMap);
				}
	
				setSelectedWMS1030_R01DetailList([1 as any]);
				if(responseData.wmsOrderDetailDtoList.length > 0){
					const firstDetail = responseData.wmsOrderDetailDtoList[0];
					setSelectedItemCdForLot(`${firstDetail.itemCd}-${firstDetail.itemStatus}`);
				} else {
					setSelectedItemCdForLot(null);
				}

			}
		}

		// setSelectedWMS1030_R01(undefined);
		setDeletedWMS1030_R01DetailList([]);
		// 저장 후 동일 wmsOrderNo 재선택 시 상세 재조회가 되도록 이전 선택 ref 초기화
		prevWmsOrderNoRef.current = undefined;
		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);
	}, [
		editWMS1030_R01, 
		selectedWMS1030_R01, 
		WMS1030_R01DetailList, 
		WMS1030_R01LotMap,
		deletedWMS1030_R01DetailList, 
		WMS1030_R01List, setWMS1030_R01List
	])

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleDetailInfoCode = useCallback((headerData: WMS1030_R01HeaderDto): Partial<WMS1030_R01HeaderDto> => {
		const defaults: Partial<WMS1030_R01HeaderDto> = {};

		//일자를 당일로 초기화
		defaults.orderDt = formatDate(new Date());
	
		if (!validateString(headerData.inoutMethod) && inoutMethodList.length > 0) defaults.inoutMethod = inoutMethodList[0].minorCd;

		if (!validateString(headerData.logicCenter) && wmsCdList.length > 0) { defaults.logicCenter = wmsCdList[0].minorCd; }
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;

		if (!validateString(headerData.compCd) && compCdList.length > 0) defaults.compCd = compCdList[0].compCd;

		const warehouseResult = validateWorkplaceWarehouse({
			mode: 'WMS1030_R01',
			warehouseCdList,
			wmsCdList,
			logicCenter: headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter,
		});
		if (!warehouseResult.valid) {
			return defaults;
		}
		if (warehouseResult.mode !== 'WMS1030_R01') {
			return defaults;
		}
		const warehouseCdListToUse = warehouseResult.warehouseCdListToUse;

		if (!validateString(headerData.warehouseCd) && warehouseCdListToUse.length > 0) {
			defaults.warehouseCd = warehouseCdListToUse[0].warehouseCd;
		}
		defaults.warehouseCd = headerData.warehouseCd ? headerData.warehouseCd : defaults.warehouseCd;

		defaults.inoutClass = defaultWMS1030_R01HeaderRow().inoutClass || '230';
	
		return defaults;
	}, [inoutMethodList, wmsCdList, compCdList, warehouseCdList, wmsOutTypeCdList, validateWorkplaceWarehouse]);
	
	const handleFetchDetailList = useCallback(async (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, previousOrderNo: string | undefined) => {
		setLoadingSpinner(true);
		if (!warehouseCd) {
			showError('수주 정보의 물류정보의 조건에 맞는 창고 코드를 찾을 수 없어 출고 목록 내역을 조회할 수 없습니다.', 5000);
			setWMS1030_R01DetailList([]);
			setLoadingSpinner(false);
			return;
		}
		// 이전에 선택한 출고정보와 현재 선택한 출고정보가 같으면 상세내역 검색 중단
		if(!isNewSelection) { setLoadingSpinner(false); return; }

		let updatedDetails: WMS1030_R01DetailDto[] = [];
		try {
			const detailResponse = await getWMS1030_R01DetailList(wmsOrderNo, warehouseCd);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const currentDetailList = useWMS1030_R01Store.getState().WMS1030_R01DetailList;
				
				// itemCd와 itemStatus를 조합한 복합 키로 Map을 생성하여 정확도를 높입니다.
				const existingItemsMap = new Map<string, WMS1030_R01DetailDto>();
				currentDetailList.forEach(item => {
					if (item.itemCd && item.itemStatus) {
						const key = `${item.itemCd}-${item.itemStatus}`;
						existingItemsMap.set(key, item);
					}
				});

				const defaultItemStatus = defaultWMS1030_R01DetailRow().itemStatus;

				updatedDetails = detailData.map((value) => {
					return {
						...value,
						itemStatus: validateString(value.itemStatus) ? value.itemStatus : defaultItemStatus,
						valueIndex: value.valueIndex,
						orderIndex: value.orderIndex,
						orderIndexSeq: value.orderIndexSeq,
						orderPrice: value.orderPrice,
						orderQtyView: value.orderQty - value.transportQty - value.cancelQty,
						updateTransportQty: 0,
						stockQty: value.stockQty ?? 0,
					}
				});
				setWMS1030_R01DetailList(updatedDetails);
				setOriginalWMS1030_R01DetailList(detailData);
				setMessage(`${selectedWMS1030_R01?.compNm}의 출고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);

				setSelectedWMS1030_R01DetailList([1 as any]);
				setSelectedItemCdForLot(`${updatedDetails[0].itemCd}-${updatedDetails[0].itemStatus}`);

			} else {
				showError('상세내역이 없습니다.');
				setWMS1030_R01DetailList([]);
				setDetailFetchTrigger(false);
				setLoadingSpinner(false);
				return [];
			}
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setWMS1030_R01DetailList([]);
			setDetailFetchTrigger(false);
			setLoadingSpinner(false);
			return [];
		}
		setLoadingSpinner(false);

		return updatedDetails;
	}, [setMessage, setWMS1030_R01DetailList, setOriginalWMS1030_R01DetailList, selectedWMS1030_R01?.compNm, defaultWMS1030_R01DetailRow]);

	const handleFetchLotList = useCallback(async (warehouseCd: string, updatedDetailList: WMS1030_R01DetailDto[]) => {
		if (!warehouseCd || updatedDetailList.length === 0) {
			setWMS1030_R01LotMap(new Map<string, WMS1030_R01LotDto[]>());
			return;
		}
		setLoadingSpinner(true);
		
		try {
			// 1. DetailList의 모든 품목에 대해 Lot 리스트 조회 프로미스 배열을 생성합니다.
			const lotPromises = updatedDetailList.map(item =>
				getWMS1030_R01LotList(warehouseCd, item.itemCd, item.itemStatus)
			);

			// 2. Promise.all을 사용해 모든 Lot 조회 요청이 완료될 때까지 기다립니다.
			const lotResponses = await Promise.all(lotPromises);

			const newLotMap = new Map<string, WMS1030_R01LotDto[]>();
			
			lotResponses.forEach((response, index) => {
				const detailItem = updatedDetailList[index];
				const key = `${detailItem.itemCd}-${detailItem.itemStatus}`;
				let valueIndex = 1;
				let lotData = response.data.data.map(value => ({
					...value,
					valueIndex: valueIndex++,
					orderIndex: value.orderIndex,
					orderIndexSeq: value.orderIndexSeq,
				}));

				if (lotData && lotData.length > 0) {
					newLotMap.set(key, [...lotData]);
				} else {
					newLotMap.set(key, []);
				}
			});

			//detailTable의 실재고량을 newLotMap에 들어있는 lotQty의 합으로 업데이트
			const newDetailList = updatedDetailList.map(detail => {
				const key = `${detail.itemCd}-${detail.itemStatus}`;
				const lotQtySum = newLotMap.get(key)?.reduce((acc, lot) => acc + Number(lot.lotQty || 0), 0) || 0;
				detail.stockQty = lotQtySum;
				return detail;
			});

			// console.log('newLotMap :', Object.fromEntries(newLotMap));

			setWMS1030_R01LotMap(newLotMap);
			setWMS1030_R01DetailList(newDetailList);

		} catch (error) {
			console.error("Lot 리스트 조회 중 오류 발생:", error);
			showError("Lot 리스트를 조회하는 중 오류가 발생했습니다.");
			setLoadingSpinner(false);
			return;
		}
		setLoadingSpinner(false);

	}, [setWMS1030_R01LotMap]);


	useEffect(() => {
		currentDetailListRef.current = WMS1030_R01DetailList.map(value => ({
			...value,
			updateTransportQty: value.updateTransportQty,
		}));
	}, [WMS1030_R01DetailList]);
	
	
	useEffect(() => {
		if (!detailFetchTrigger) return;

		const fetchAllDetailsForSelectedRow = async () => {
			if (!selectedWMS1030_R01 || !selectedWMS1030_R01.wmsOrderNo) {
				if (!selectedWMS1030_R01) {
					prevWmsOrderNoRef.current = undefined;
					setWMS1030_R01DetailList([]);
					setOriginalWMS1030_R01DetailList([]);
				}
				setLoadingSpinner(false);
				return;
			}

			// 이전에 선택한 출고정보와 현재 선택한 출고정보가 다른지 확인
			// 다르면 상세 내역 조회 시 출고량 초기화
			const previousOrderNo = prevWmsOrderNoRef.current;
			const currentOrderNo = selectedWMS1030_R01.wmsOrderNo;

			const isNewSelection = previousOrderNo !== currentOrderNo;

			// 1. 출고 정보 먼저 가져오기
			const headerData = await fetchOne();

			// 2. 출하 정보 먼저 가져와서 완전한 출고 정보인지 출하 전의 출고 정보인지 검증
			// 출하 정보 존재시 수정 불가
			const apiHeaderData = await fetchTransportHeader();
			if (apiHeaderData)	setTransportComplete(true);
			else				setTransportComplete(false);

			// 3. 현재 선택된 행과 API 데이터를 합쳐 기본값을 적용할 베이스 데이터를 만듭니다.
			const baseDataForDefaults = { ...defaultWMS1030_R01HeaderRow(), ...headerData, ...(apiHeaderData || {}) };
			const defaultValues = handleDetailInfoCode(baseDataForDefaults);

			//최종적으로 사용할 warehouseCd, logicCenter 결정
			const logicCenterToUse = baseDataForDefaults.logicCenter || defaultValues.logicCenter || '';
			const warehouseCdToUse = baseDataForDefaults.warehouseCd || defaultValues.warehouseCd || '';

			// 4. 출고 헤더 정보 업데이트
			setEditWMS1030_R01({
				...defaultWMS1030_R01HeaderRow(),
				...headerData,					// 선택된 행의 정보가 베이스
				...defaultValues,				// selectedWMS1030_R01의 기본값으로 비어있는 필드 채우기
				logicCenter: logicCenterToUse,
				warehouseCd: warehouseCdToUse,
			});

			// 5. 분리된 함수를 호출하여 상세 내역을 등록.
			const updatedDetailList = await handleFetchDetailList(selectedWMS1030_R01.wmsOrderNo, warehouseCdToUse, isNewSelection, previousOrderNo);
			if (updatedDetailList && updatedDetailList.length > 0) {
				handleFetchLotList(warehouseCdToUse, updatedDetailList);
			}
			setDetailFetchTrigger(false);
			// 이전
			prevWmsOrderNoRef.current = selectedWMS1030_R01.wmsOrderNo;
			setLoadingSpinner(false);
		};

		fetchAllDetailsForSelectedRow();
	}, [selectedWMS1030_R01, handleDetailInfoCode, setEditWMS1030_R01, handleFetchDetailList, handleFetchLotList, detailFetchTrigger, setDetailFetchTrigger]);

	
	// LotMap의 inputOutQty 총합을 계산하여 DetailList의 updateTransportQty에 반영
	useEffect(() => {
		const lotQtySums = new Map<string, number>();

		let valid = true;
		let crashItemCd = '';
		//해당 품목의 lot출고량을 계산해서 품목의 출고총량 계산
		WMS1030_R01LotMap.forEach((lots, itemCd) => {
			const sum = lots.reduce((acc, lot) => {
				// 삭제된 lot은 계산에서 제외
				if (deletedWMS1030_R01LotList.includes(lot.valueIndex.toString())) {
					return acc;
				}
				return acc + Number(lot.inputOutQty || 0);
			}, 0);
			lotQtySums.set(itemCd, sum);
		});

		const needsUpdate = WMS1030_R01DetailList.some(detailItem => {
			const sum = lotQtySums.get(`${detailItem.itemCd}-${detailItem.itemStatus}`);
			return sum !== undefined && detailItem.updateTransportQty !== sum;
		});

		if (needsUpdate && valid) {
			const newDetailList = WMS1030_R01DetailList.map(detailItem => {
				const sum = lotQtySums.get(`${detailItem.itemCd}-${detailItem.itemStatus}`);
				
				if (sum !== undefined && detailItem.updateTransportQty !== sum) {
					return { ...detailItem, updateTransportQty: sum };
				}
				return detailItem;
			});
			setWMS1030_R01DetailList(newDetailList);
		}

	}, [WMS1030_R01LotMap, deletedWMS1030_R01LotList, WMS1030_R01DetailList, setWMS1030_R01DetailList]);
	
	return {
		handleExcelClick,
		fetchData,
		defaultWMS1030_R01HeaderRow,
		defaultWMS1030_R01DetailRow,
		defaultWMS1030_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleDetailInfoCode,
		handleFetchDetailList,
		handleFetchLotList,
	};
}
